import actions from "./actions";

const initState = {
    transactionReadState: false,
    transaction: {},
    company: {},
    contact: {},
    files: [],
    readFileState: false,
    file: {},
    transactionPayexState: false,
    eInvoiceNotSubscribed: false,
    transactionRequestEInvoiceState: false,
    transactionRejectEInvoiceState: false,
};

export default function appReducer(state = initState, action = {}) {
    switch (action.type) {
        case actions.PUBLIC_TRANSACTION_READ_REQUEST:
        case actions.PUBLIC_TRANSACTION_READ_V2_REQUEST:
        case actions.PUBLIC_TRANSACTION_READ_V3_REQUEST:
            return {
                ...state,
                transactionReadState: 'request',
            };
        case actions.PUBLIC_TRANSACTION_READ_SUCCESS:
        case actions.PUBLIC_TRANSACTION_READ_V2_SUCCESS:
        case actions.PUBLIC_TRANSACTION_READ_V3_SUCCESS:
            return {
                ...state,
                transactionReadState: 'success',
                transaction: action.transaction,
                company: action.company,
                contact: action.contact,
            };
        case actions.PUBLIC_TRANSACTION_READ_ERROR:
        case actions.PUBLIC_TRANSACTION_READ_V2_ERROR:
        case actions.PUBLIC_TRANSACTION_READ_V3_ERROR: {
            if (action.error.statusCode === 403) {
                return {
                    ...state,
                    transactionReadState: 'error',
                    eInvoiceNotSubscribed: true,
                };
            }
            return {
                ...state,
                transactionReadState: 'error',
            };
        }
        case actions.PUBLIC_TRANSACTION_RESET_STATE:
            return {
                ...initState,
            };
        case actions.PUBLIC_TRANSACTION_SET_FILES:
            return {
                ...state,
                files: action.files,
            };
        case actions.PUBLIC_TRANSACTION_READ_FILE_REQUEST:
            return {
                ...state,
                readFileState: 'request',
            };
        case actions.PUBLIC_TRANSACTION_READ_FILE_SUCCESS:
            return {
                ...state,
                readFileState: 'success',
                file: action.file,
            };
        case actions.PUBLIC_TRANSACTION_CREATE_PAYEX_PAYMENT_REQUEST:
            return {
                ...state,
                transactionPayexState: 'request',
                request: action.request,
                openInNewTab: action.openInNewTab,
            };
        case actions.PUBLIC_TRANSACTION_CREATE_PAYEX_PAYMENT_SUCCESS:
            return {
                ...state,
                transactionPayexState: 'success',
            };
        case actions.PUBLIC_TRANSACTION_REQUEST_E_INVOICE_REQUEST:
            return {
                ...state,
                transactionRequestEInvoiceState: 'request',
            };
        case actions.PUBLIC_TRANSACTION_REQUEST_E_INVOICE_SUCCESS:
            return {
                ...state,
                transactionRequestEInvoiceState: 'success',
            };
        case actions.PUBLIC_TRANSACTION_REJECT_E_INVOICE_REQUEST:
            return {
                ...state,
                transactionRejectEInvoiceState: 'request',
            };
        case actions.PUBLIC_TRANSACTION_REJECT_E_INVOICE_SUCCESS:
            return {
                ...state,
                transactionRejectEInvoiceState: 'success',
            };
        default:
            return state;
    }
}
